import React from "react";
import { FaCloudUploadAlt, FaCheckCircle, FaStore } from "react-icons/fa";

function InventorySourceSelector({
  source,
  onSourceChange,
  uploadFile,
  onUploadFileChange,
  shopifyConfig,
  onShopifyConfigChange,
  uploadLabel = "Inventory File",
  uploadAccept = ".xlsx,.xls"
}) {
  const handleUploadChange = (event) => {
    const nextFile = event.target.files?.[0] || null;
    onUploadFileChange(nextFile);
  };

  const updateConfig = (key, value) => {
    onShopifyConfigChange({ ...shopifyConfig, [key]: value });
  };

  return (
    <div className="tool-form-group">
      <div className="linesheet-source-toggle">
        <button
          type="button"
          className={`linesheet-source-toggle-button ${source === "upload" ? "active" : ""}`}
          onClick={() => onSourceChange("upload")}
        >
          <span className="linesheet-source-toggle-title">
            <FaCloudUploadAlt /> Upload Excel
          </span>
          <span className="linesheet-source-toggle-copy">
            Use a local inventory file
          </span>
        </button>
        <button
          type="button"
          className={`linesheet-source-toggle-button ${source === "shopify" ? "active" : ""}`}
          onClick={() => onSourceChange("shopify")}
        >
          <span className="linesheet-source-toggle-title">
            <FaStore /> Shopify Sync
          </span>
          <span className="linesheet-source-toggle-copy">
            Fetch directly from Shopify
          </span>
        </button>
      </div>

      {source === "upload" ? (
        <div className="linesheet-source-panel">
          <div className="tool-field-stack">
            <label className="tool-label">{uploadLabel}</label>
            <div className={`file-upload-wrapper ${uploadFile ? "has-file" : ""}`}>
              <input
                type="file"
                accept={uploadAccept}
                className="file-upload-input"
                onClick={(event) => {
                  event.target.value = null;
                }}
                onChange={handleUploadChange}
              />
              <div className="file-upload-text">
                {uploadFile ? (
                  <span className="file-selected-text">
                    <FaCheckCircle /> {uploadFile.name}
                  </span>
                ) : (
                  <>
                    <FaCloudUploadAlt /> <span>Choose File</span>
                  </>
                )}
              </div>
            </div>
            {uploadFile && (
              <button
                type="button"
                className="tool-link-button"
                onClick={() => onUploadFileChange(null)}
              >
                Clear file
              </button>
            )}
          </div>
        </div>
      ) : (
        <div className="linesheet-source-panel shopify-source-panel shopify-source-panel-compact">
          <div className="tool-field-stack tool-field-stack-compact">
            <label className="tool-label tool-label-compact">Location</label>
            <select
              className="tool-input tool-input-compact"
              value={shopifyConfig.location}
              onChange={(e) => updateConfig("location", e.target.value)}
            >
              <option value="Main Store">Main Store</option>
              <option value="Outlet Store">Outlet Store</option>
              <option value="All">All Locations</option>
            </select>
          </div>
          <div className="tool-field-stack tool-field-stack-compact">
            <label className="tool-label tool-label-compact">Product Vendors</label>
            <input
              type="text"
              className="tool-input tool-input-compact"
              placeholder="e.g. Django & Juliette, Ara (comma-separated)"
              value={shopifyConfig.vendors}
              onChange={(e) => updateConfig("vendors", e.target.value)}
            />
          </div>
          <div className="tool-field-stack tool-field-stack-compact">
            <label className="tool-label tool-label-compact">Exclude Tags</label>
            <div className="shopify-checkbox-row shopify-checkbox-row-compact">
              <label className="shopify-checkbox-label shopify-checkbox-label-compact">
                <input
                  type="checkbox"
                  checked={shopifyConfig.excludeArchive}
                  onChange={(e) => updateConfig("excludeArchive", e.target.checked)}
                />
                Archive
              </label>
              <label className="shopify-checkbox-label shopify-checkbox-label-compact">
                <input
                  type="checkbox"
                  checked={shopifyConfig.excludeRS}
                  onChange={(e) => updateConfig("excludeRS", e.target.checked)}
                />
                RS
              </label>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default InventorySourceSelector;
